<script lang="ts">
	import { createDialog } from 'svelte-headlessui';
	import Transition from 'svelte-transition';
	import { STARTER_DAILY_MATERIALS } from '$lib/constants';
	export let usageExceededErrorDetail: string;

	const dialog = createDialog({ label: 'Usage Exceeded' });

	export function openDialog() {
		dialog.open();
	}

	export function closeDialog() {
		dialog.close();
	}
</script>

<div class={`fixed w-screen h-screen inset-0 ${$dialog.expanded ? 'z-50' : 'z-[-10]'}`}>
	<Transition show={$dialog.expanded}>
		<button
			aria-label="Close dialog"
			class="w-full h-full bg-zinc-900 bg-opacity-25 cursor-default focus:outline-none"
			on:click={dialog.close}
		></button>
		<div
			class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-fit p-10 flex flex-col justify-start items-start text-zinc-200 bg-zinc-900 rounded-tr rounded-br border border-zinc-800 shadow-md z-50 text-sm"
			use:dialog.modal
		>
			<button
				aria-label="Close dialog"
				class="absolute w-8 h-8 top-2 right-2 rounded-2xl hover:bg-zinc-700 text-zinc-200 text-md"
				on:click={dialog.close}
			>
				<i class="fa-solid fa-times text-md"></i>
			</button>
			{#if usageExceededErrorDetail == 'Exceeded Free Material Generator usage limit.'}
				<div class="text-lg">
					You've reached today's limit for material generation. The Free plan allows {STARTER_DAILY_MATERIALS} material generation daily.
				</div>
				<div class="h-4"></div>
				<div>Please check back tomorrow, or upgrade to Pro for more generations.</div>
			{:else if usageExceededErrorDetail == 'Exceeded Pro Material Generator usage limit.'}
				<div class="text-lg">You've reached the Pro plan's monthly limit for material generation.</div>
				<div class="h-4"></div>
				<div>Try emailing support@iliad.ai if you need increased limits.</div>
			{:else}
				<div class="text-lg">Usage limits exceeded for the current plan.</div>
			{/if}
			<div class="h-6"></div>
			<a
				class="w-full py-4 flex flex-row justify-center items-center text-sm font-semibold rounded shadow-lg text-zinc-900 bg-cyan-300 hover:bg-cyan-200"
				href="/plan">Get more generations</a
			>
		</div>
	</Transition>
</div>